const AddNewAddressIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-5.61958e-08 5.33073L0 6.66406L4.66667 6.66406L5.33333 5.9974L4.66667 5.33073L-5.61958e-08 5.33073Z"
        fill="#DA291C"
      />
      <path
        d="M5.33463 12L6.66797 12L6.66797 7.33333L6.0013 6.66667L5.33464 7.33333L5.33463 12Z"
        fill="#DA291C"
      />
      <path
        d="M12 5.33073L12 6.66406L7.33333 6.66406L6.66667 5.9974L7.33333 5.33073L12 5.33073Z"
        fill="#DA291C"
      />
      <path
        d="M6.66536 2.33127e-07L5.33203 0L5.33203 4.66667L5.9987 5.33333L6.66536 4.66667L6.66536 2.33127e-07Z"
        fill="#DA291C"
      />
    </svg>
  )
}

export default AddNewAddressIcon
